/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component } from '@angular/core';
import {EntryScheduleItem} from "../../models/schedule/EntryScheduleItem";

/**
 * Generated class for the EntryDetailsComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'entry-details-component',
  templateUrl: 'entry-details-component.html'
})
export class EntryDetailsComponent {

  entry: EntryScheduleItem;

  constructor() {
    console.log('Hello EntryDetailsComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/entry-details-component/entry-details-component.ts